export default __webpack_public_path__ + "static/media/it park.ea7356e6.png";